// @ts-nocheck
import { hubService } from '@/services';
export default {
    // 라이더 관리 자동 차감 그룹 (C,R,U,D)
    /**
     * 라이더 관리 자동 차감 그룹 생성
     * @param {object} payload
     * @param {string} payload.name 생성할 자동 차감 그룹의 이름.
     */
    async postWorkerCashAutoDeductGroup({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const response = await hubService.postWorkerCashAutoDeductGroup({
            hubId,
            payload,
        });
        commit('POST_WORKER_CASH_AUTO_DEDUCT_GROUP', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 조회
     */
    async getWorkerCashAutoDeductGroupList({ commit, rootGetters }) {
        // 상세 및 수정 페이지에서는 허브셀렉트 박스가 아닌 선택된 라이더의 허브를 기준으로 작동합니다.
        const selectedWorkerHubId = rootGetters['workerManagement/workerEdit/getterSelectedWorkerHubId'];
        const hubId = selectedWorkerHubId ?? rootGetters['hubSelector/getterSubscribeHubId'];
        const response = await hubService.getWorkerCashAutoDeductGroup({
            hubId,
        });
        const workerEditGroup = rootGetters['workerManagement/workerEdit/getterSelectedWorkerDetailCashAutoDeductGroup'];
        // 라이더 수정 시 현재 소속 그룹 최상단
        if (workerEditGroup) {
            response.data = response.data
                .filter((group) => group.id !== workerEditGroup.id);
            response.data.unshift(workerEditGroup);
        }
        commit('GET_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 수정
     * @param {object} payload
     * @param {number} payload.groupId 수정할 자동 차감 그룹.
     * @param {string} payload.name 수정할 자동 차감 그룹의 이름.
     */
    async putWorkerCashAutoDeductGroup({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.putWorkerCashAutoDeductGroup({
            hubId,
            id: groupId,
            payload,
        });
        commit('PUT_WORKER_CASH_AUTO_DEDUCT_GROUP', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 삭제
     * @param {object} payload
     * @param {number} payload.groupId 삭제할 자동 차감 그룹.
     */
    async deleteWorkerCashAutoDeductGroup({ state, commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.deleteWorkerCashAutoDeductGroup({
            hubId,
            id: groupId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const deletedFeeGroupList = state.workerCashAutoDeductGroupList
            .filter((group) => group.id !== groupId);
        commit('DELETE_WORKER_CASH_AUTO_DEDUCT_GROUP', deletedFeeGroupList);
        commit('PUBLISH_WORKER_CASH_AUTO_DEDUCT_GROUP_DELETED', groupId);
    },
    // 라이더 관리 자동 차감 그룹 스케줄 설정 (C,R,U,D)
    /**
     * 라이더 관리 자동 차감 그룹 스케줄 생성
     * @param {object} payload
     * @param {number} payload.groupId 자동 차감 그룹 스케줄을 생성할 그룹.
     * @param {string} payload.scheduleName 생성할 자동 차감 그룹 스케줄의 스케줄명.
     * @param {string} payload.scheduleType 생성할 자동 차감 그룹 스케줄의 라이더 자동 차감 스케줄 타입.
     * @param {number} payload.amount 생성할 자동 차감 그룹 스케줄의 금액.
     * @param {string} payload.accountByWorker 생성할 자동 차감 그룹 스케줄의 라이더 캐시 타입.
     * @param {string} payload.fromAt 생성할 자동 차감 그룹 스케줄의 적용 시작일.
     * @param {string} payload.toAt 생성할 자동 차감 그룹 스케줄의 적용 종료일.
     * @param {string} [payload.memo] 생성할 자동 차감 그룹 스케줄의 메모.
     */
    async postWorkerCashAutoDeductGroupOption({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.postWorkerCashAutoDeductGroupOption({
            hubId,
            groupId,
            payload,
        });
        commit('POST_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 스케줄 조회
     * @param {object} payload
     * @param {number} payload.groupId 자동 차감 그룹 스케줄을 조회할 그룹.
     */
    async getWorkerCashAutoDeductGroupOptionList({ commit, rootGetters }, payload = {}) {
        // 상세 및 수정 페이지에서는 허브셀렉트 박스가 아닌 선택된 라이더의 허브를 기준으로 작동합니다.
        const selectedWorkerHubId = rootGetters['workerManagement/workerEdit/getterSelectedWorkerHubId'];
        const hubId = selectedWorkerHubId ?? rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.getWorkerCashAutoDeductGroupOption({
            hubId,
            groupId,
        });
        commit('GET_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION_LIST', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 스케줄 수정
     * @param {object} payload
     * @param {number} payload.groupId 수정할 자동 차감 그룹 스케줄이 속한 그룹.
     * @param {number} payload.optionId 수정할 자동 차감 그룹 스케줄.
     * @param {string} payload.scheduleName 수정할 자동 차감 그룹 스케줄의 스케줄명.
     * @param {string} payload.scheduleType 수정할 자동 차감 그룹 스케줄의 라이더 자동 차감 스케줄 타입.
     * @param {number} payload.amount 수정할 자동 차감 그룹 스케줄의 금액.
     * @param {string} payload.accountByWorker 수정할 자동 차감 그룹 스케줄의 라이더 캐시 타입.
     * @param {string} payload.fromAt 수정할 자동 차감 그룹 스케줄의 적용 시작일.
     * @param {string} payload.toAt 수정할 자동 차감 그룹 스케줄의 적용 종료일.
     * @param {string} [payload.memo] 수정할 자동 차감 그룹 스케줄의 메모.
     */
    async putWorkerCashAutoDeductGroupOption({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', optionId = '' } = payload;
        const response = await hubService.putWorkerCashAutoDeductGroupOption({
            hubId,
            groupId,
            id: optionId,
            payload,
        });
        commit('PUT_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 스케줄 삭제
     * @param {object} payload
     * @param {number} payload.groupId 삭제할 자동 차감 그룹 스케줄이 속한 그룹.
     * @param {number} payload.optionId 삭제할 자동 차감 그룹 스케줄.
     */
    async deleteWorkerCashAutoDeductGroupOption({ state, commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', optionId = '' } = payload;
        const response = await hubService.deleteWorkerCashAutoDeductGroupOption({
            hubId,
            groupId,
            id: optionId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const deletedFeeGroupOptionList = state.workerCashAutoDeductGroupOptionList
            .filter((option) => option.id !== optionId);
        commit('DELETE_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION', deletedFeeGroupOptionList);
    },
    setSelectedWorkerCashAutoDeductGroup({ commit }, group = {}) {
        commit('SET_SELECTED_WORKER_CASH_AUTO_DEDUCT_GROUP', group);
    },
    // 다이얼로그 핸들링
    setOpenEditWorkerCashAutoDeductGroupDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_EDIT_WORKER_CASH_AUTO_DEDUCT_GROUP_DIALOG', isOpen);
    },
    setOpenEditWorkerCashAutoDeductGroupOptionDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_EDIT_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION_DIALOG', isOpen);
    },
    setEditWorkerCashAutoDeductGroup({ commit }, option = {}) {
        commit('SET_EDIT_WORKER_CASH_AUTO_DEDUCT_GROUP', option);
    },
    setEditWorkerCashAutoDeductGroupOption({ commit }, option = {}) {
        commit('SET_EDIT_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION', option);
    },
    // 초기화
    clearWorkerCashAutoDeductGroupDialog({ commit }) {
        commit('CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST');
        commit('CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION_LIST');
        commit('CLEAR_SELECTED_WORKER_CASH_AUTO_DEDUCT_GROUP');
    },
    clearWorkerCashAutoDeductGroupList({ commit }) {
        commit('CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST');
    },
    clearWorkerCashAutoDeductGroupOptionList({ commit }) {
        commit('CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_OPTION_LIST');
    },
    clearSelectedWorkerCashAutoDeductGroup({ commit }) {
        commit('CLEAR_SELECTED_WORKER_CASH_AUTO_DEDUCT_GROUP');
    },
    // 라이더 수수료 그룹 변경 다이얼로그 전용
    setOpenCashAutoDeductGroupSelectDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_CASH_AUTO_DEDUCT_GROUP_SELECT_DIALOG', isOpen);
    },
};
